<mat-spinner *ngIf="loadSaveDispenseMedicine == true" style="margin-left: 135px;margin-right: 135px;margin-top: 30px;margin-bottom: 30px;"></mat-spinner>
<div *ngIf="loadSaveDispenseMedicineSuccess == true">
    <h1 mat-dialog-title>Dialog dispense medicine success</h1>
    <div mat-dialog-content>This dialog show dispense medicine success.</div>
    <div mat-dialog-actions style="display: flex;justify-content: flex-end;">
      <button mat-button mat-dialog-close>OK</button>
    </div>
</div>